const customButtonFunctionType = {
    ADD_FORM : 'addForm',

    CLOSE_FORM : 'closeForm',

    EXPORT_FORM : 'exportForm',

    IMPORT_FORM : 'importForm',

    INSIGHT_URL : 'insightUrl',

    REMOTE_FUNCTION : 'remoteFunction',

    URL : 'url'

};

angular.module('gw-um-j2js')
    .constant('customButtonFunctionType', customButtonFunctionType);